const fetchApiWu = (url, requestOptions, methodName, showLoad=true, hideAtEnd=false) => {
    const spinnerContainer = document.getElementById('spinnerContainer');
    showLoad && showSpinnerMain(spinnerContainer);
    return fetch(url, requestOptions)
            .then((data) => {
                showLoad && !hideAtEnd && hideSpinnerMain(spinnerContainer);
                const contentType = data?.headers?.get("content-type");
                try {
                    if(contentType?.indexOf("application/json") === -1) {
                        return data.text()
                    } else if(data.ok) {
                        return data.json()
                    } else if(!contentType && data.ok === false) {
                        return {
                            status : data.status,
                            statusText: data.statusText,
                            ok: false,
                            error: true
                        }    
                    } else {
                        return data.json().then((innerData) => {
                            if(typeof innerData === "object" && !Array.isArray(innerData) && innerData !== null) {
                                return {
                                    status : data.status,
                                    statusText: data.statusText,
                                    ok: false,
                                    error: true,
                                    ...innerData
                                }
                            } else {
                                return innerData
                            } 
                        })
                    }
                } catch(e) {
                    return {
                        status : data.status,
                        statusText: data.statusText,
                        ok: false,
                        error: true
                    }
                }
            })
            .then((data) => {
                if(methodName && window.logAPIEvent && window.amplitude) {
                    window.logAPIEvent(`/${methodName}`, requestOptions.body, data);
                }
                return data;
            })
}  